import stbAPIGateway from '../../../../services/stbAPIGateway';

export const getHubConfig = async ({ rootGetters }, { clientSid }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);

  const client = await stbApi.getClientHubConfig(clientSid);
  return client;
};
